$(".slide-header").click(advanceSlide)
let jumps = [];
let currentSlide = 0;
let autoInterval;


if($(".auto-advance").length){
  setTimeout(()=>{
    autoInterval = setInterval(function(){
      // console.log("interval!");
      advanceSlide(1);
    },2500);
  },2500);
}

function advanceSlide(e){
  // console.log(e)
  // clearInterval(autoInterval);
  if($(e.target).closest(".links").length){
    return;
  } else {
    e.preventDefault && e.preventDefault();
    e.stopPropagation && e.stopPropagation();
  }
  let slide,index;
  if(e.target){
    slide = $(e.target).closest(".slide-header");
    index = slide.index();
    currentSlide = index;
    clearInterval(autoInterval)
  } else {
    index = currentSlide+e;
    if(index<0) index = jumps.length-1;
    if(index>(jumps.length-1)) index = 0;
    currentSlide = index;
  }
  if(slide && slide.hasClass("fullbleed")){
    $("#logo").removeClass("black")
  } else {
    $("#logo").addClass("black")
  }
  // console.log("SWITCHING TO INDEX",index)
  $("#slider-container").attr("on-slide",index)
  $("#slide-title-controller").css("transform",`translateX(calc(-50% + ${getOffset(index)}px))`)
  $(`#slide-title-controller .links`).removeClass("links")
  $(`#slide-title-controller .slide-header:eq(${index})`).addClass("links")
  let newColor = $(`#slide-title-controller .slide-header:eq(${index})`).attr("data-color");
  // console.log("new color",newColor,$(`#slide-title-controller .slide-header`));
  $(`#slide-title-controller .slide-header a`).css("color",newColor);
  $(".slider-dot.active").removeClass("active");
  $(`.slide:eq(${index}) .slider-dot:eq(${index})`).addClass("active")
}

function getOffset(index){
  let difference = (jumps[index].w - jumps[0].w)/2;
  return (jumps[index].l*-1) - difference;
}

function headerWidth(index){
  return $(".slide-header:eq("+index+")").width()
}

function renderMenu(){
  jumps = [];
  let space = window.innerWidth < 480 ? window.innerWidth * .1 : window.innerWidth * .05;
  let firstOffset = .5*(window.innerWidth * .75 - $("#slide-title-controller .slide-header:eq(0) span").width());
  let left = 0;
  let sizes = $("#slide-title-controller .slide-header").map((i,e)=>{
    let height = $(`#slider .slide-header:eq(${i})`).height();
    let width = $(`#slider .slide-header:eq(${i})`).width();
    if(height>200){
      $(`#slider .slide-header:eq(${i})`).css("width","min-content");
    //   console.log("two lines",width,height)
    } else {
      $(`#slider .slide-header:eq(${i})`).css("width","auto");
    }
    jumps.push({w: width, l: left})
    if(i>0){
      $(e).css({"left":left+firstOffset+"px", width: width});
      // $()
    }
    left += space + width;
  })
  advanceSlide(0);
}

document.addEventListener('keydown', function(e){
    switch(e.which) {
        case 37: // left
        advanceSlide(-1);
        break;
        case 39: // right
        advanceSlide(1);
        break;
        default: return; // exit this handler for other keys
    }
    // e.preventDefault(); // prevent the default action (scroll / move caret)
});



  var touchstartX = 0;
  var touchstartY = 0;
  var touchendX = 0;
  var touchendY = 0;

  var swipeArea = document.querySelector('#slider-container');
  var autoAdvance = $('.auto-advance').length;
  swipeArea.addEventListener('touchstart', function(event) {
      touchstartX = event.touches? event.touches[0].pageX : event.pageX;
      touchstartY = event.touches? event.touches[0].pageX : event.pageY;
    //   console.log(event)
      console.log(`start: ${touchstartX} ${touchstartY}`)
  }, false);

  swipeArea.addEventListener('touchend', function(event) {
    //   console.log(event)
      touchendX = event.changedTouches? event.changedTouches[0].pageX : event.pageX;
      touchendY = event.changedTouches? event.changedTouches[0].pageX : event.pageY;
    //   console.log(`end: ${touchendX} ${touchendY}`)
      if(autoAdvance)
        handleGesture();
  }, false);

function handleGesture() {
    var swiped = 'swiped: ';
    if (touchendX < touchstartX) {
        // console.log(swiped + 'left!');
        advanceSlide(1);
        clearInterval(autoInterval)
    }
    if (touchendX > touchstartX) {
        // console.log(swiped + 'right!');
        advanceSlide(-1);
        clearInterval(autoInterval)
    }
}

renderMenu()

// Enable slide transitions only after the first paint
// so that slide 1 shows instantly without a fade-in flicker
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    document.getElementById('slider-container').classList.add('slider-ready');
  });
});

// window.onresize = () => {
// //   renderMenu() 
// };

// $("#slide-title-controller").css({"transform":`translateX(${headerWidth(0)/2}px)`})
